import { render, staticRenderFns } from "./medicine_refrigerator_history.vue?vue&type=template&id=9833693e&scoped=true&"
import script from "./medicine_refrigerator_history.vue?vue&type=script&lang=js&"
export * from "./medicine_refrigerator_history.vue?vue&type=script&lang=js&"
import style0 from "./medicine_refrigerator_history.vue?vue&type=style&index=0&id=9833693e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9833693e",
  null
  
)

export default component.exports